import styled from 'styled-components';
import { Col, Divider, Row } from 'antd';
import { Trans, useTranslation } from 'next-i18next';
import { FC } from 'react';

import useWindowResize from '@source/hooks/useWindowResize';
import { Typography } from '@design-system/components';
import { IPointContent, KeyPoint } from './content';

const StyledContentWrapper = styled.div`
  ${(props) => props.theme.typo.familyGoogle.regular}
  .ant-divider {
    margin-top: 5px;
    margin-bottom: 12px;
    border-top: 1px solid ${(props) => props.theme.color.primaryBase};
  }
`;

const StyledHeading = styled.h4`
  ${(props) => props.theme.typo.familyGoogle.bold};
  margin-bottom: 0;
  color: ${(props) => props.theme.color.primaryBase};
  font-size: 14px;
  line-height: 22px;
  @media (min-width: 768px) {
    font-size: 28px;
    line-height: 36px;
  }
`;

const StyledLabel = styled(Typography)`
  font-weight: bold !important;
  color: ${(props) => props.theme.color.quartzColor};
`;

const StyledInspectItems = styled.ul`
  list-style: none;
  padding-left: 0;
  .content-items {
    list-style: none;
    padding-left: 0;
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 24px;
    color: #8b807c;
  }

  @media (min-width: 768px) {
    font-size: 14px;
    line-height: 22px;
    .content-items {
      font-size: 14px;
      line-height: 22px;
    }
  }
`;

interface Props {
  keyPoint: KeyPoint;
  items: IPointContent[];
}
const CCPOInspectionPointItem: FC<Props> = ({ keyPoint, items }) => {
  const [width] = useWindowResize();
  const { t } = useTranslation('ccpo');
  const firstLabel = items[0]?.label;

  return (
    <StyledContentWrapper>
      <Row align="bottom" gutter={[8, 8]}>
        <Col xs={8}>
          <StyledHeading>
            <Trans ns="ccpo" defaults={`ccpo.inspectionPointList.${keyPoint}Title`} components={{ br: <br /> }} />
          </StyledHeading>
        </Col>
        <Col xs={16}>
          <StyledLabel variant={width > 768 ? 'mHeader' : 'body'}>{t(firstLabel)}</StyledLabel>
        </Col>

        <Divider />
      </Row>
      <Row gutter={[8, 8]}>
        <Col xs={8} />
        <Col xs={16} md={16}>
          <StyledInspectItems>
            {items.map((item, idx) => (
              <li key={idx} className="item">
                {idx > 0 && (
                  <StyledLabel variant={width > 768 ? 'mHeader' : 'body'}>
                    {t(item.label)}
                    <Divider />
                  </StyledLabel>
                )}
                <ul className="content-items">
                  {item.content.map((c, i) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <li key={i}>{t(c)}</li>
                  ))}
                </ul>
              </li>
            ))}
          </StyledInspectItems>
        </Col>
      </Row>
    </StyledContentWrapper>
  );
};

export default CCPOInspectionPointItem;
